import { formatPrice, isCustomCurrency, convertPrice } from "@stadium/helpers/currency";

export const computeUserFundsSummary = ({
  storeBalance,
  storeDetails = {},
  cartItemsTotal,
  displayCurrencyCode,
  conversionRates,
}) => {
  const { storeCurrencyCode, storeCurrencyPrefix, storeCurrencySuffix } = storeDetails;

  const cartItemsTotalInStoreCurrency = convertPrice({
    from: displayCurrencyCode,
    to: storeCurrencyCode,
    value: cartItemsTotal,
    conversionRates,
  });

  const getPointsLeft = () => {
    const balancePoints = Math.max(0, storeBalance - cartItemsTotalInStoreCurrency);
    if (isCustomCurrency(storeCurrencyCode)) return Math.floor(balancePoints);
    return balancePoints;
  };
  const pointsLeft = getPointsLeft();
  const youPayPoints = cartItemsTotalInStoreCurrency - storeBalance;

  let formattedAmount = formatPrice(pointsLeft, {
    prefix: storeCurrencyPrefix,
    suffix: storeCurrencySuffix,
    currencyCode: storeCurrencyCode,
  });

  if (pointsLeft) return { formattedAmount, isPointsLeft: Boolean(pointsLeft) };

  const youPayPointsInDisplayCurrency = convertPrice({
    from: storeCurrencyCode,
    to: displayCurrencyCode,
    value: youPayPoints,
    conversionRates,
  });

  formattedAmount = formatPrice(youPayPointsInDisplayCurrency, {
    currencyCode: displayCurrencyCode,
  });

  return { formattedAmount, isPointsLeft: Boolean(pointsLeft) };
};
